module.exports = __webpack_public_path__ + "img/banner.edb2d21e.jpg";